import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ModalService } from 'src/app/services/modal/modal.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { AlarmsPatient } from 'src/app/utils/interfaces/new/alarms-patient.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-alarme',
  templateUrl: './add-alarme.component.html',
  styleUrls: ['./add-alarme.component.scss',
    '../../../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class AddAlarmeComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public formGroup: FormGroup;
  public isError = false;
  public isSubmitDisabled: boolean = false;
  public errorMessage = '';
  public minDate = moment().format("YYYY-MM-DD");
  public idSource: string;
  public alarmeName: string = "";
  public alarmeDate: moment.Moment = undefined;
  public destinataires = [];
  // public typeOccurence = ['Aucun', 'Jours', 'Mois', 'Années'];
  // public delaiOccurence = [1];

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _cabinet: CabinetService,
    private _strUtilsSrv: StringUtilsService,
    private _modal: ModalService,
    private _view: ViewContainerRef
  ) { }

  async ngOnInit(): Promise<void> {
    const loader = this._modal.openLoading(this._view);

    try {
      const destinatairesCabinet = await this._cabinet.findCurrentCabinetDestinataire();
      const allIds: string[] = ['ALL'];
      
      this.destinataires.push({ id: 'ALL', libelle: 'Tout le cabinet' });
      
      for (let destinataire of destinatairesCabinet) {
        if (!destinataire.disabled) {
          this.destinataires.push({ id: destinataire.id, libelle: destinataire.nom.toLocaleUpperCase() + ' ' + this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom) });
          allIds.push(destinataire.id);
        }
      }
      this._previousDestinataires = allIds;

      this.formGroup = this._formBuilder.group({
        alarme: [this.alarmeName, [Validators.required, Validators.maxLength(250)]],
        destinataire: [allIds, Validators.required],
        // dateFin: [this.alarmeDate], on n'affiche plus la date de fin pour le moment car les récurrences ne sont pas utilisées
        dateDebut: [this.alarmeDate, Validators.required],
        // typeOccurence: ['Aucun'],
        // delaiOccurence: [''],
      });

      // this.formGroup.get('typeOccurence').valueChanges.subscribe(selectedValue => {
      //   switch (selectedValue) {
      //     case 'Jours': {
      //       this.delaiOccurence = [];
      //       for (let i = 1; i < 31; i++) {
      //         this.delaiOccurence.push(i);
      //       }
      //       break;
      //     }
      //     case 'Mois': {
      //       this.delaiOccurence = [];
      //       for (let i = 1; i < 12; i++) {
      //         this.delaiOccurence.push(i);
      //       }
      //       break;
      //     }
      //     case 'Années': {
      //       this.delaiOccurence = [];
      //       for (let i = 1; i < 11; i++) {
      //         this.delaiOccurence.push(i);
      //       }
      //       break;
      //     }
      //   }
      // });
    } catch (error) {
      console.error("Erreur lors de la récupération des destinataires", error);
    } finally {
      this._modal.close(loader);
    }
  }

  private _previousDestinataires: string[] = [];

  public onDestinatairesChange() {
    const currentValues: string[] = this.formGroup.controls['destinataire'].value || [];
    const prevValues = this._previousDestinataires || [];
    
    const hasAllCurrently = currentValues.includes('ALL');
    const hadAllPreviously = prevValues.includes('ALL');
    
    if (hasAllCurrently && !hadAllPreviously) {
        const allIds = this.destinataires.map(d => d.id);
        this.formGroup.controls['destinataire'].setValue(allIds);
    } else if (!hasAllCurrently && hadAllPreviously) {
        this.formGroup.controls['destinataire'].setValue([]);
    } else if (hasAllCurrently && currentValues.length < prevValues.length) {
        const newValues = currentValues.filter(id => id !== 'ALL');
        this.formGroup.controls['destinataire'].setValue(newValues);
    } else if (!hasAllCurrently && currentValues.length === this.destinataires.length - 1) {
        const allIds = this.destinataires.map(d => d.id);
        this.formGroup.controls['destinataire'].setValue(allIds);
    }
    
    this._previousDestinataires = this.formGroup.controls['destinataire'].value;
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  public async onSubmit(): Promise<void> {
    this.isSubmitDisabled = true;
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      // if ((this.formGroup.controls['typeOccurence'] && this.formGroup.controls['typeOccurence'].value == 'Aucun') && this.formGroup.controls['delaiOccurence'].value) {
      //   this.isError = true;
      //   this.errorMessage = "Veuillez sélectionner un type d'occurence si vous renseignez un délai";
      //   this.isSubmitDisabled = false;
      //   return;
      // }
      // if (!this.formGroup.controls['dateFin'].value &&
      //   (this.formGroup.controls['delaiOccurence'].value ||
      //   (this.formGroup.controls['typeOccurence'].value && this.formGroup.controls['typeOccurence'].value != 'Aucun'))
      // ) {
      //   this.isError = true;
      //   this.errorMessage = "Veuillez renseigner la date de fin de l'occurence";
      //   this.isSubmitDisabled = false;
      //   return;
      // }
      let object: AlarmsPatient = {
        alarme: this.formGroup.controls['alarme'].value,
        idSource: this.idSource,
        dateAlarme: moment(this.formGroup.controls['dateDebut'].value, "DD/MM/YYYY").format("YYYY-MM-DD"),
        disabled: false,
        destinataireAlarmes: this.formGroup.controls['destinataire'].value ? this.formGroup.controls['destinataire'].value.filter(id => id !== 'ALL').map((id: string) => {
          return {
            idProfil: id,
            view: false,
            processed: false
          }
        }) : undefined,
        // On fige car pour l'instant les récurrence c'est pas fonctionnele
      }
      // if (this.formGroup.controls['dateFin'].value) {
      //   object.alarmeRecurrence = {
      //     dateDebut: moment(this.formGroup.controls['dateDebut'].value, "DD/MM/YYYY").format("YYYY-MM-DD"),
      //     dateFin: moment(this.formGroup.controls['dateFin'].value, "DD/MM/YYYY").format("YYYY-MM-DD"),
      //     delaiOccurence: 0,
      //     typeOccurence: "Aucun",
      //   };
      // }
      this.closeAddEditModal(object);
    } else {
      this.isSubmitDisabled = false;
    }
  }
}
